<template>
  <DashboardHeader>
    <div>
      <v-row>
        <h3 class="mx-auto mt-6">Capture Payment</h3>
      </v-row>
      <v-divider></v-divider>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <input type="date" class="mip" v-model="dateInput" label="Payment Date" />
            </v-col>
            <v-col cols="12" md="6">
              <input
                placeholder="Student ID"
                type="text"
                class="mip"
                v-model="sidInput"
                :rules="nameRules"
                @change="getSelectedStudent()"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row v-if="sidInput != null && surName != undefined">
            <v-col cols="12" md="6">
              <v-text-field :value="selStudent.lname" readonly label="Surname"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field :value="selStudent.fname" readonly label="First Names"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <h4 class="mx-auto mt-6">{{studentSearchError}}</h4>
          </v-row>
          <v-divider></v-divider>
          <div v-if="surName != null" ref="container">
            <AmountDescriptionField></AmountDescriptionField>
          </div>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              fab
              small
              color="primary"
              v-if="surName != null"
              @click="addPaymentDescriptionField()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <div class="mx-auto">
              <v-btn :color="getThemeColor" dark class="mr-3" :disabled="!valid">
                <v-icon small left>mdi-database-plus</v-icon>Record
              </v-btn>
              <v-btn color="primary" dark @click="goBack()">
                <v-icon small left>mdi-arrow-left</v-icon>Back
              </v-btn>
            </div>
          </v-row>
        </v-container>
      </v-form>
      <v-divider></v-divider>
    </div>
  </DashboardHeader>
</template>

<script>
import axios from "../../plugins/axios";
import Vue from "vue";
import DashboardHeader from "@/components/DashboardHeader.vue";
import AmountDescriptionField from "@/components/Incomes/AmountDescriptionField.vue";
export default {
  components: { DashboardHeader, AmountDescriptionField },

  data() {
    return {
      nameRules: [v => !!v || "Field is required"],
      students: [],
      dateInput: null,
      studentSearchError: "",
      sidInput: null,
      surName: null,
      valid: false,
      selStudent: { fname: "", lname: "", class: "" },
      cats: [],
      totalPayment: 0,
      selDate: "",
      items: [{ description: "School Fees", quantity: 1, price: "0" }]
    };
  },
  computed: {
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  methods: {
    createPDF() {
      const content = document.getElementById("invoice").outerHTML;
      this.$store.commit("setPdfHTML", content);
      this.$router.push({ name: "generate-pdf" });
    },
    total() {
      this.totalPayment = this.items.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    getSelectedStudent() {
      const sid = event.target.value;
      axios
        .postDataWithToken(
          "/auth/get-selected-student-payment",
          { sid: sid },
          this.getAccessToken
        )
        .then(student => {
          if (student.lname) {
            this.selStudent = student;
            this.surName = student.lname;
          } else {
            this.surName = undefined;
            this.studentSearchError =
              "No Student Found For SID: " + this.sidInput;
          }
        });
    },
    getDate() {
      this.selDate = event.target.value;
    },
    addRow() {
      this.items.push({ description: "Description", quantity: 1, price: 0 });
    },
    goBack() {
      this.$router.back();
    },
    addPaymentDescriptionField() {
      const ComponentClass = Vue.extend(AmountDescriptionField);
      const instance = new ComponentClass({
        propsData: { type: "primary" }
      });
      instance.$mount();
      this.$refs.container.appendChild(instance.$el);
    }
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    }
  }
};
</script>
<style lang="scss">
.mip {
  outline: none;
  border-bottom: 1px solid black;
  width: 100%;
  color: black;
}
</style>